/* Group trip page: shows the organiser's kit, who's in, and lets each golfer pay for their own. */
(function () {
  var root = document.querySelector('[data-trip]');
  if (!root) return;
  var endpoint = root.getAttribute('data-endpoint'), mockupEndpoint = root.getAttribute('data-mockup-endpoint');
  var products = JSON.parse(root.querySelector('[data-trip-products]').textContent);
  var fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: products.currency || 'CHF' });
  function money(c) { return fmt.format(c / 100); }
  function $(sel) { return root.querySelector(sel); }
  var qs = new URLSearchParams(location.search);
  var slug = (qs.get('t') || '').toLowerCase().replace(/[^a-z0-9-]/g, '');
  var key = qs.get('k') || '';
  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];
  var trip = null, fit = 'men', size = '';

  function show(sel, on) { var el = $(sel); if (el) el.hidden = !on; }
  function niceDate(d) { return new Date(d + 'T12:00:00').toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' }); }

  if (!slug) { show('[data-trip-loading]', false); show('[data-trip-missing]', true); return; }
  fetch(endpoint + '?t=' + encodeURIComponent(slug) + (key ? '&k=' + encodeURIComponent(key) : ''))
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (d) {
      show('[data-trip-loading]', false);
      if (!d || d.error) { show('[data-trip-missing]', true); return; }
      trip = d; render();
    })
    .catch(function () { show('[data-trip-loading]', false); show('[data-trip-missing]', true); });

  /* ---------- the products this trip uses ---------- */
  function productKey() { return trip.type === 'cap' ? 'cap' : trip.type === 'polo' ? (trip.tier === 'tour' ? 'tpolo' : 'polo') : (trip.tier === 'tour' ? 'tkit' : 'kit'); }
  function colourName() { return trip.kit === 'navy' ? 'Navy' : 'White'; }
  function fitOf(v) { var o = (v.o || []).map(function (x) { return String(x).toLowerCase().replace(/\u2019/g, "'"); }); for (var i = 0; i < o.length; i++) { if (/^women/.test(o[i])) return 'women'; if (/^men/.test(o[i])) return 'men'; } return ''; }
  function variants() {
    return (products[productKey()] || []).filter(function (v) { return (v.o || []).map(function (x) { return String(x).toLowerCase(); }).indexOf(colourName().toLowerCase()) > -1; });
  }
  function fitted() { return variants().some(function (v) { return fitOf(v); }); }
  function sizesFor(f) {
    var seen = {};
    variants().forEach(function (v) { if (fitted() && fitOf(v) !== f) return; (v.o || []).forEach(function (x) { if (SIZE_ORDER.indexOf(String(x).toUpperCase()) > -1) seen[String(x).toUpperCase()] = v.ok !== false; }); });
    return SIZE_ORDER.filter(function (s) { return s in seen; });
  }
  function chosen() {
    if (trip.type === 'cap') return variants()[0];
    return variants().find(function (v) { var o = (v.o || []).map(function (x) { return String(x).toUpperCase(); }); return o.indexOf(size) > -1 && (!fitted() || fitOf(v) === fit); });
  }

  /* ---------- page ---------- */
  function render() {
    var name = trip.trip || trip.place;
    document.title = name + ' group kit \u2013 ForeFrontier';
    $('[data-trip-kicker]').textContent = (trip.organiser ? trip.organiser + '\u2019s ' : '') + 'group kit';
    $('[data-trip-title]').textContent = name;
    $('[data-trip-coords]').textContent = [trip.place !== name ? trip.place : '', trip.coords].filter(Boolean).join(' \u00b7 ');
    $('[data-trip-deadline]').textContent = trip.open
      ? 'Orders close ' + niceDate(trip.deadline) + (trip.days_left <= 1 ? (trip.days_left === 0 ? ' (today)' : ' (tomorrow)') : ' (' + trip.days_left + ' days left)')
      : 'Orders closed on ' + niceDate(trip.deadline);
    if (trip.joined) {
      $('[data-trip-count]').textContent = trip.joined + (trip.expected ? ' of ' + trip.expected : '') + ' in so far';
      var ul = $('[data-trip-names]');
      trip.names.forEach(function (n) { var li = document.createElement('li'); li.textContent = n; ul.appendChild(li); });
      show('[data-trip-who]', true);
    }
    show('[data-trip-main]', true);
    photos();
    if (trip.open) form(); else show('[data-trip-closed]', true);
    if (trip.manage) manage();
  }

  /* real product photos, made from the exact embroidery files */
  function photos() {
    var box = $('[data-trip-photos]');
    var colour = trip.kit === 'navy' ? 'navy' : 'stone';
    var wanted = [];
    if (trip.type !== 'polo' && trip.cap_art) wanted.push({ product: 'cap', art: trip.cap_art, label: 'Cap', extras: [['embroidery_back', trip.cap_back_art]] });
    if (trip.type !== 'cap' && trip.polo_art) wanted.push({ product: trip.tier === 'tour' ? 'polo_tour' : 'polo', art: trip.polo_art, label: trip.tier === 'tour' ? 'Under Armour polo' : 'Polo',
      extras: [['embroidery_sleeve_left_top', trip.sleeve_art], ['embroidery_sleeve_right_top', trip.brand_art]] });
    box.innerHTML = '';
    wanted.forEach(function (w) {
      var fig = document.createElement('figure'); fig.className = 'tp__photo is-loading';
      fig.innerHTML = '<span>Making your photo\u2026</span>'; box.appendChild(fig);
      mockup(w, colour).then(function (src) {
        fig.classList.remove('is-loading'); fig.innerHTML = '';
        var img = document.createElement('img'); img.src = src; img.alt = w.label + ' embroidered with the ' + trip.place + ' crest'; fig.appendChild(img);
        var cap = document.createElement('figcaption'); cap.textContent = w.label; fig.appendChild(cap);
      }).catch(function () {
        fig.classList.remove('is-loading'); fig.classList.add('is-art', 'is-' + colour); fig.innerHTML = '';
        var img = document.createElement('img'); img.src = w.art; img.alt = 'The ' + trip.place + ' crest'; fig.appendChild(img);
      });
    });
  }
  function load(url) {
    return fetch(url).then(function (r) { return r.blob(); }).then(function (blob) {
      return new Promise(function (res, rej) { var fr = new FileReader(); fr.onload = function () { res(fr.result); }; fr.onerror = rej; fr.readAsDataURL(blob); });
    }).then(function (dataUrl) {
      return new Promise(function (res, rej) { var im = new Image(); im.onload = function () { res({ dataUrl: dataUrl, w: im.naturalWidth, h: im.naturalHeight }); }; im.onerror = rej; im.src = dataUrl; });
    });
  }
  function mockup(w, colour) {
    var extras = (w.extras || []).filter(function (x) { return x[1]; });
    return Promise.all([load(w.art)].concat(extras.map(function (x) { return load(x[1]); }))).then(function (all) {
      var a = all[0];
      var more = extras.map(function (x, i) { return { placement: x[0], image: all[i + 1].dataUrl, width: all[i + 1].w, height: all[i + 1].h }; });
      return fetch(mockupEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ product: w.product, colour: colour, place: trip.place, trip: trip.trip || '', coords: trip.coords || '', width: a.w, height: a.h, image: a.dataUrl, extras: more }) });
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.images && d.images.length) return d.images[0];
      if (!d.key) throw new Error('mockup');
      return poll(d.key, 0);
    });
  }
  function poll(k, n) {
    return new Promise(function (res) { setTimeout(res, 2500); }).then(function () {
      return fetch(mockupEndpoint + '?key=' + encodeURIComponent(k)).then(function (r) { return r.json(); });
    }).then(function (d) {
      if (d.status === 'done' && d.images && d.images.length) return d.images[0];
      if (d.status === 'failed' || n > 24) throw new Error('mockup');
      return poll(k, n + 1);
    });
  }

  /* ---------- the order form ---------- */
  function form() {
    show('[data-trip-form]', true);
    var item = trip.type === 'cap' ? 'Cap' : trip.type === 'polo' ? (trip.tier === 'tour' ? 'Under Armour polo' : 'Polo') : (trip.tier === 'tour' ? 'Cap and Under Armour polo' : 'Cap and polo');
    $('[data-trip-item]').textContent = item + ', ' + (trip.kit === 'navy' ? 'navy' : 'white');
    if (trip.type !== 'cap') {
      if (fitted() && sizesFor('women').length) {
        show('[data-trip-fit-field]', true);
        root.querySelectorAll('[data-fit]').forEach(function (b) {
          b.addEventListener('click', function () {
            fit = b.getAttribute('data-fit'); size = '';
            root.querySelectorAll('[data-fit]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
            sizes(); price();
          });
        });
      }
      show('[data-trip-size-field]', true);
      sizes();
    }
    price();
    $('[data-trip-pay]').addEventListener('click', pay);
  }
  function sizes() {
    var box = $('[data-trip-sizes]'); box.innerHTML = '';
    sizesFor(fit).forEach(function (s) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'tp__chip'; b.textContent = s; b.setAttribute('aria-pressed', String(s === size));
      b.addEventListener('click', function () { size = s; box.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); }); price(); $('[data-trip-msg]').textContent = ''; });
      box.appendChild(b);
    });
  }
  function price() {
    var v = chosen() || variants()[0];
    if (!v) { $('[data-trip-full]').textContent = ''; return; }
    var save = Math.round(v.price * (trip.pct || 0) / 100);
    $('[data-trip-full]').textContent = money(v.price);
    $('[data-trip-save-label]').textContent = 'Group discount (' + trip.pct + '%)';
    $('[data-trip-save]').textContent = '\u2212' + money(save);
    $('[data-trip-total]').textContent = money(v.price - save);
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'cart'); return d; }); });
  }
  function pay() {
    var msg = $('[data-trip-msg]'), nameIn = $('[data-trip-name]'), btn = $('[data-trip-pay]');
    if (!nameIn.value.trim()) { msg.textContent = 'Add your name so the organiser knows you\u2019re in.'; nameIn.focus(); return; }
    if (trip.type !== 'cap' && !size) { msg.textContent = 'Pick your polo size.'; return; }
    var v = chosen();
    if (!v) { msg.textContent = 'That size isn\u2019t available. Try another.'; return; }
    var props = {
      'Place': trip.place, 'Trip name': trip.trip || '', 'Kit': trip.kit === 'navy' ? 'Navy kit, white stitching' : 'White kit, navy stitching',
      'Name': nameIn.value.trim(), 'Crest approved': 'Yes, by the organiser', '_art': trip.art_key, '_trip': trip.slug
    };
    if (trip.coords) props['Coordinates'] = trip.coords;
    if (trip.type !== 'cap') props['Polo'] = trip.tier === 'tour' ? 'Under Armour Tour' : 'Classic';
    if (fit === 'women' && trip.type !== 'cap') props['Fit'] = 'Women\u2019s';
    btn.disabled = true; btn.textContent = 'Preparing your checkout\u2026';
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var updates = {};
      cart.items.forEach(function (it) { if (it.properties && (it.properties._trip || it.properties._art !== undefined)) updates[it.key] = 0; });
      return Object.keys(updates).length ? post('/cart/update.js', { updates: updates }) : null;
    }).then(function () {
      return post('/cart/add.js', { items: [{ id: v.id, quantity: 1, properties: props }] });
    }).then(function () {
      return post('/cart/update.js', { attributes: { 'Trip kit': 'Yes', 'Group trip': trip.slug } });
    }).then(function () {
      window.location.href = trip.code ? '/discount/' + encodeURIComponent(trip.code) + '?redirect=%2Fcheckout' : '/checkout';
    }).catch(function () {
      btn.disabled = false; btn.textContent = 'Pay for mine';
      msg.textContent = 'Something went wrong adding this to your basket. Please try again.';
    });
  }

  /* ---------- organiser view ---------- */
  function manage() {
    show('[data-trip-manage]', true);
    var tb = $('[data-trip-members]');
    if (!trip.members.length) tb.innerHTML = '<tr><td colspan="2">Nobody yet. Share the link in the group chat.</td></tr>';
    trip.members.forEach(function (m) {
      var tr = document.createElement('tr');
      var a = document.createElement('td'); a.textContent = m.name;
      var b = document.createElement('td'); b.textContent = m.items.join(', ');
      tr.appendChild(a); tr.appendChild(b); tb.appendChild(tr);
    });
    $('[data-trip-nudge]').textContent = trip.nudge;
    var share = location.origin + location.pathname + '?t=' + trip.slug;
    function copy(btn, text) {
      (navigator.clipboard ? navigator.clipboard.writeText(text) : Promise.reject()).then(function () { var t = btn.textContent; btn.textContent = 'Copied'; setTimeout(function () { btn.textContent = t; }, 1600); }, function () { window.prompt('Copy this:', text); });
    }
    $('[data-trip-copy-nudge]').addEventListener('click', function (e) { copy(e.currentTarget, trip.nudge); });
    $('[data-trip-copy-link]').addEventListener('click', function (e) { copy(e.currentTarget, share); });
    var closeBtn = $('[data-trip-close]');
    if (!trip.open) closeBtn.hidden = true;
    closeBtn.addEventListener('click', function () {
      if (!window.confirm('Close orders now? Nobody else will be able to order through the link.')) return;
      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'close', t: trip.slug, k: key }) })
        .then(function () { location.reload(); });
    });
  }
})();
